<template>
  <v-flex sm10 offset-sm1>
    <v-container fluid pt-5 mt-5>
      <v-flex v-if="loading" text-md-center>
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </v-flex>
      <v-flex v-else>
        <v-card class="mb-5 elevation-0">
          <v-flex md12>
            <v-tabs centered color="#dbeafeba" show-arrows dark  v-model="tab" >
              <v-toolbar-title lass="title">
                <div class="display-1 mt-3 mr-5 tamany_titol">{{ 'shop.title' | t }}</div>
              </v-toolbar-title>
              <v-tabs-slider color="primary ratlla" />
              <v-tab href="#tab-snews" class="text_tab color_digital clear_full separa_tab">
                {{ 'playground.title_digital' | t }}
              </v-tab>
              <v-tab v-if="this.getUserType === 3" href="#tab-ondemand" class="primary--text ">
                {{ 'shop.title_ondemand' | t }}
                <v-icon class="primary--text">add_shopping_cart</v-icon>
              </v-tab>
              <v-tab-item value="tab-snews">
                <v-card flat>
                  <v-card-text>
                    <shop-news />
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="this.getUserType === 3" value="tab-ondemand">
                <v-card flat>
                  <v-card-text>
                    <shop-ondemand />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-card>
      </v-flex>
      <faqs></faqs>
    </v-container>
  </v-flex>
</template>

<script>
import ShopNews from "@/components/ShopNews";
import ShopOndemand from "@/components/ShopOndemand";
import { mapGetters, mapActions } from "vuex";
import Faqs from "@/components/Faqs";

export default {
  components: {
    ShopNews,
    ShopOndemand,
    Faqs
  },
  computed: {
    ...mapGetters(["getUserType", "getUserId", "getServer", "getTokenHeader"])
  },
  data: () => ({
    loading: true
  }),
  created() {
    this.$http
      .get(
        `${this.getServer}/users/${this.getUserId}/consumers`,
        this.getTokenHeader
      )
      .then(data => {
        if (data.data) {
          this.setMyConsumers(data.data);
          this.loading = false;
        }
      })
      .catch(() => {
        this.rmKey();
      });
  },
  methods: {
    ...mapActions(["rmKey", "setMyConsumers"])
  }
};
</script>

<style scoped>
  .clear_full {
    text-transform: none !important;
  }
</style>
<style scoped>
  .tamany_titol{
    color: #27408b !important;
    caret-color: #27408b !important;
    font-size: 28px !important;
    font-weight: 400;
    line-height: 20px !important;
    letter-spacing: normal !important;
    font-family: 'Roboto', sans-serif !important;
  }
  .ratlla{
    height: 3px !important;
  }
  .separa_tab{
    /*padding: 6px 20px !important;*/
    position: static !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .clear_full {
    text-transform: none !important;    
  }
  .text_tab{
    font-size: 20px !important;
  }
  .color_digital {
    color :#80d484 !important;
  }
  </style>